import React, { useEffect, useState, useCallback } from "react";
import { FaEdit, FaPlus, FaKey, FaSearch } from "react-icons/fa";
import axios from "axios";
import md5 from "md5";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { Navigate } from "react-router-dom";
import "../../css/TelefonosNotificacion.css";
import "../../css/Usuarios.css";

const Usuarios = () => {
  const cookies = new Cookies();
  const [userName, setUserName] = useState("");
  const [perfil, setRol] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [estado, setEstado] = useState("");
  const [datos, setDatos] = useState([]);
  const [datosFiltrados, setDatosFiltrados] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);
  const [modalContrasenaVisible, setModalContrasenaVisible] = useState(false);
  const [usuarioCambioContrasena, setUsuarioCambioContrasena] = useState(null);
  const [nuevaContrasena, setNuevaContrasena] = useState("");
  const [verNuevaContrasena, setVerNuevaContrasena] = useState(false);
  const [formulario, setFormulario] = useState({
    nombreUsuario: "", 
    nombresApellidos: "", 
    correo: "",
    contrasenaHash: "", 
    estado: true, 
    perfilId: "1",
    usuCrea: userName, 
    usuMod: userName,
  });

  const elementosPorPagina = 10;
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const usarMockup = false; // ⚠️ CAMBIAR A false CUANDO LAS APIs ESTÉN LISTAS

  // ═══════════════════════════════════════════════════════
  // 📦 DATOS MOCKUP - Mientras se crean las APIs
  // ═══════════════════════════════════════════════════════
  const datosMockup = [
    { id: 1, nombreUsuario: "admin", nombresApellidos: "Administrador Sistema", correo: "admin@empresa.com", estado: true, perfilId: 1 },
    { id: 2, nombreUsuario: "jperez", nombresApellidos: "Juan Pérez González", correo: "jperez@empresa.com", estado: true, perfilId: 2 },
    { id: 3, nombreUsuario: "mgarcia", nombresApellidos: "María García López", correo: "mgarcia@empresa.com", estado: true, perfilId: 2 },
    { id: 4, nombreUsuario: "cmartinez", nombresApellidos: "Carlos Martínez Ruiz", correo: "cmartinez@empresa.com", estado: true, perfilId: 2 },
    { id: 5, nombreUsuario: "lrodriguez", nombresApellidos: "Laura Rodríguez Silva", correo: "lrodriguez@empresa.com", estado: false, perfilId: 2 },
    { id: 6, nombreUsuario: "pfernandez", nombresApellidos: "Pedro Fernández Castro", correo: "pfernandez@empresa.com", estado: true, perfilId: 2 },
    { id: 7, nombreUsuario: "asanchez", nombresApellidos: "Ana Sánchez Morales", correo: "asanchez@empresa.com", estado: true, perfilId: 2 },
    { id: 8, nombreUsuario: "rlopez", nombresApellidos: "Roberto López Díaz", correo: "rlopez@empresa.com", estado: false, perfilId: 2 },
    { id: 9, nombreUsuario: "sgomez", nombresApellidos: "Sofía Gómez Torres", correo: "sgomez@empresa.com", estado: true, perfilId: 1 },
    { id: 10, nombreUsuario: "dhernandez", nombresApellidos: "Diego Hernández Vargas", correo: "dhernandez@empresa.com", estado: true, perfilId: 2 },
    { id: 11, nombreUsuario: "cramirez", nombresApellidos: "Carolina Ramírez Flores", correo: "cramirez@empresa.com", estado: true, perfilId: 2 },
    { id: 12, nombreUsuario: "jmartinez", nombresApellidos: "Jorge Martínez Romero", correo: "jmartinez@empresa.com", estado: false, perfilId: 2 },
  ];

  // ═══════════════════════════════════════════════════════
  // 🔄 FETCH USUARIOS - Con mockup o API real
  // ═══════════════════════════════════════════════════════
  const fetchUsuarios = useCallback(async (mantenerPagina = false) => {
    try {
      let data = [];
      
      if (usarMockup) {
        // 📦 Simular delay de API
        await new Promise(resolve => setTimeout(resolve, 300));
        data = [...datosMockup];
      } else {
        // 🌐 Llamada real a la API
        const response = await axios.get(`${baseURL}/api/Usuarios/ObtenerUsuarios`);
        data = response.data.data || [];
      }

      // Transformar datos
      const transformado = data.map((item) => ({
        id: item.id,
        nombreUsuario: item.nombreUsuario,
        nombresApellidos: item.nombresApellidos,
        correo: item.correo,
        estado: item.estado === true ? "Activo" : "Inactivo",
        estadoBoolean: item.estado,
        perfilId: item.perfilId === 1 ? "Administrador" : "Estándar",
        perfilIdNumerico: item.perfilId,
      }));

      setDatos(transformado);
      
      // Solo resetear a página 1 si NO queremos mantener la página actual
      if (!mantenerPagina) {
        setPaginaActual(1);
      }
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
      Swal.fire({ 
        icon: "error", 
        title: "Error al cargar usuarios", 
        text: "Intenta nuevamente." 
      });
    }
  }, [baseURL, usarMockup]);

  // ═══════════════════════════════════════════════════════
  // 🔍 FILTRADO REACTIVO
  // ═══════════════════════════════════════════════════════
  useEffect(() => {
    const filtrados = datos.filter((item) => {
      const coincideBusqueda =
        !busqueda ||
        item.nombreUsuario.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.nombresApellidos.toLowerCase().includes(busqueda.toLowerCase()) ||
        item.correo.toLowerCase().includes(busqueda.toLowerCase());
      const coincideEstado = estado === "" || item.estado === estado;
      return coincideBusqueda && coincideEstado;
    });
    setDatosFiltrados(filtrados);
  }, [datos, busqueda, estado]);

  // Resetear paginación solo cuando cambian los filtros
  useEffect(() => {
    setPaginaActual(1);
  }, [busqueda, estado]);

  useEffect(() => {
    setUserName(cookies.get("nombreUsuario") || "");
    setRol(cookies.get("perfil") || "");
    fetchUsuarios();
  }, [fetchUsuarios]);

  // ═══════════════════════════════════════════════════════
  // 📝 ABRIR MODALES
  // ═══════════════════════════════════════════════════════
  const abrirModalAgregar = () => {
    setModoEdicion(false);
    setFormulario({ 
      nombreUsuario: "", 
      nombresApellidos: "", 
      correo: "", 
      contrasenaHash: "", 
      estado: true, 
      perfilId: "1", 
      usuCrea: userName, 
      usuMod: userName 
    });
    setModalVisible(true);
  };

  const abrirModalEditar = (usuario) => {
    setModoEdicion(true);
    setFormulario({ 
      id: usuario.id,
      nombreUsuario: usuario.nombreUsuario, 
      nombresApellidos: usuario.nombresApellidos, 
      correo: usuario.correo, 
      contrasena: "", 
      estado: usuario.estado === "Activo", 
      perfilId: usuario.perfilId === "Administrador" ? "1" : "2", 
      usuCrea: userName, 
      usuMod: userName 
    });
    setUsuarioSeleccionado(usuario.nombreUsuario);
    setModalVisible(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    // Nombre de usuario: sin espacios ni números
    if (name === "nombreUsuario") {
      const soloLetras = value.replace(/[\s0-9]/g, "").toUpperCase();
      setFormulario({ ...formulario, [name]: soloLetras });
      return;
    }
    setFormulario({ ...formulario, [name]: type === "checkbox" ? checked : value });
  };

  // ═══════════════════════════════════════════════════════
  // 💾 GUARDAR USUARIO - Mockup o API
  // ═══════════════════════════════════════════════════════
  const guardarUsuario = async () => {
    // Validaciones
    if (!formulario.nombreUsuario || !formulario.nombresApellidos || !formulario.correo) {
      Swal.fire({ 
        toast: true, 
        icon: "warning", 
        title: "Todos los campos obligatorios deben estar completos.", 
        position: "top-end", 
        showConfirmButton: false, 
        timer: 3000, 
        timerProgressBar: true 
      });
      return;
    }
    
    if (!modoEdicion && !formulario.contrasenaHash) {
      Swal.fire({ 
        toast: true, 
        icon: "warning", 
        title: "La contraseña es obligatoria.", 
        position: "top-end", 
        showConfirmButton: false, 
        timer: 3000, 
        timerProgressBar: true 
      });
      return;
    }

    if (!modoEdicion) {
      const yaExiste = datosFiltrados.some(u => 
        u.nombreUsuario.toLowerCase() === formulario.nombreUsuario.toLowerCase()
      );
      if (yaExiste) {
        Swal.fire({ 
          toast: true, 
          icon: "error", 
          title: "El nombre de usuario ya está registrado.", 
          position: "top-end", 
          showConfirmButton: false, 
          timer: 3000, 
          timerProgressBar: true 
        });
        return;
      }
    }

    const payload = { 
      ...formulario, 
      contrasena: formulario.contrasenaHash ? md5(formulario.contrasenaHash) : undefined, 
      estado: formulario.estado ? true : false 
    };

    try {
      if (usarMockup) {
        // 📦 MODO MOCKUP - Simular guardado
        await new Promise(resolve => setTimeout(resolve, 500));
        
        if (modoEdicion) {
          // Actualizar en mockup
          const index = datosMockup.findIndex(u => u.nombreUsuario === usuarioSeleccionado);
          if (index !== -1) {
            datosMockup[index] = {
              ...datosMockup[index],
              nombresApellidos: payload.nombresApellidos,
              correo: payload.correo,
              estado: payload.estado,
              perfilId: parseInt(payload.perfilId)
            };
          }
          Swal.fire({ 
            icon: "success", 
            title: "Éxito", 
            text: "Usuario actualizado correctamente (MOCKUP)." 
          });
        } else {
          // Crear en mockup
          const nuevoId = Math.max(...datosMockup.map(u => u.id)) + 1;
          datosMockup.push({
            id: nuevoId,
            nombreUsuario: payload.nombreUsuario,
            nombresApellidos: payload.nombresApellidos,
            correo: payload.correo,
            estado: payload.estado,
            perfilId: parseInt(payload.perfilId)
          });
          Swal.fire({ 
            icon: "success", 
            title: "Éxito", 
            text: "Usuario creado correctamente (MOCKUP)." 
          });
        }
      } else {
        // 🌐 MODO API REAL
        if (modoEdicion) {
          await axios.post(`${baseURL}/api/Usuarios/ActualizarUsuario`, payload);
          Swal.fire({ 
            icon: "success", 
            title: "Éxito", 
            text: "Usuario actualizado correctamente." 
          });
        } else {
          await axios.post(`${baseURL}/api/Usuarios/InsertarUsuario`, payload);
          Swal.fire({ 
            icon: "success", 
            title: "Éxito", 
            text: "Usuario creado correctamente." 
          });
        }
      }
      
      setModalVisible(false);
      setUsuarioSeleccionado(null);
      await fetchUsuarios(true); // Mantener página actual
    } catch (error) {
      Swal.fire("Error", "Error al guardar: " + error, "error");
    }
  };

  // ═══════════════════════════════════════════════════════
  // 🔑 CAMBIAR CONTRASEÑA
  // ═══════════════════════════════════════════════════════
  const abrirModalCambioContrasena = (usuario) => {
    setUsuarioCambioContrasena(usuario);
    setUsuarioSeleccionado(usuario.nombreUsuario);
    setNuevaContrasena("");
    setModalContrasenaVisible(true);
  };

  const guardarNuevaContrasena = async () => {
    if (!nuevaContrasena) {
      Swal.fire({ 
        toast: true, 
        icon: "warning", 
        title: "Debes ingresar la nueva contraseña.", 
        position: "top-end", 
        showConfirmButton: false, 
        timer: 3000, 
        timerProgressBar: true 
      });
      return;
    }

    try {
      if (usarMockup) {
        // 📦 MODO MOCKUP - Simular cambio de contraseña
        await new Promise(resolve => setTimeout(resolve, 500));
        Swal.fire({ 
          toast: true, 
          icon: "success", 
          title: "Contraseña actualizada correctamente (MOCKUP).", 
          position: "top-end", 
          showConfirmButton: false, 
          timer: 3000, 
          timerProgressBar: true 
        });
      } else {
        // 🌐 MODO API REAL
        await axios.post(`${baseURL}/api/Usuarios/CambiarContrasena`, { 
          nombreUsuario: usuarioCambioContrasena.nombreUsuario, 
          contrasena: md5(nuevaContrasena) 
        });
        Swal.fire({ 
          toast: true, 
          icon: "success", 
          title: "Contraseña actualizada correctamente.", 
          position: "top-end", 
          showConfirmButton: false, 
          timer: 3000, 
          timerProgressBar: true 
        });
      }
      
      setModalContrasenaVisible(false);
      setUsuarioSeleccionado(null);
    } catch (error) {
      Swal.fire({ 
        toast: true, 
        icon: "error", 
        title: "No se pudo cambiar la contraseña.", 
        position: "top-end", 
        showConfirmButton: false, 
        timer: 3000, 
        timerProgressBar: true 
      });
    }
  };

  // ═══════════════════════════════════════════════════════
  // 📄 PAGINACIÓN
  // ═══════════════════════════════════════════════════════
  const indexInicio = (paginaActual - 1) * elementosPorPagina;
  const indexFin = indexInicio + elementosPorPagina;
  const datosPaginados = datosFiltrados.slice(indexInicio, indexFin);
  const totalPaginas = Math.ceil(datosFiltrados.length / elementosPorPagina);

  // Rango de páginas visibles (máx 5)
  const rangoInicio = Math.max(1, Math.min(paginaActual - 2, totalPaginas - 4));
  const rangoFin = Math.min(totalPaginas, rangoInicio + 4);
  const paginasVisibles = Array.from({ length: rangoFin - rangoInicio + 1 }, (_, i) => rangoInicio + i);

  if (perfil && perfil !== "Administrador") return <Navigate to="/inicio" />;

  return (
    <div className="telefonos-container">
      <div className="telefonos-card">

        {/* ══════════════════════════════════════════════════════ */}
        {/* 🎯 BANNER DE MODO MOCKUP */}
        {/* ══════════════════════════════════════════════════════ */}
        {usarMockup && (
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '12px 20px',
            borderRadius: '8px',
            marginBottom: '20px',
            textAlign: 'center',
            fontWeight: '600',
            boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
          }}>
            📦 MODO MOCKUP ACTIVO - Los cambios NO se guardan en la base de datos
          </div>
        )}

        {/* Header */}
        <div className="card-header-custom d-flex align-items-center justify-content-between">
          <h3 className="card-title-custom">
            <i className="fas fa-users mr-2"></i>
            Gestión de Usuarios
          </h3>
          <button className="btn-agregar-custom" onClick={abrirModalAgregar}>
            <FaPlus style={{ marginRight: 6 }} /> Nuevo Usuario
          </button>
        </div>

        <div className="form-section">
          {/* Filtros */}
          <div className="usuarios-filtros-wrap">
            {/* Buscador */}
            <div className="usuarios-search-wrap">
              <FaSearch className="usuarios-search-icon" />
              <input
                type="text"
                className="custom-input usuarios-search-input"
                placeholder="Buscar por usuario, nombre o correo..."
                autoComplete="off"
                value={busqueda}
                onChange={(e) => setBusqueda(e.target.value)}
              />
            </div>

            {/* Estado */}
            <div className="usuarios-filter-item">
              <label className="usuarios-filter-label">Estado</label>
              <select
                className="custom-input"
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="Activo">Activo</option>
                <option value="Inactivo">Inactivo</option>
              </select>
            </div>

            {/* Contador */}
            <div className="usuarios-contador">
              <span className="usuarios-badge-count">
                {datosFiltrados.length} usuario{datosFiltrados.length !== 1 ? "s" : ""}
              </span>
            </div>
          </div>

          {/* Tabla */}
          <div className="table-responsive usuarios-table-wrap">
            <table className="usuarios-table">
              <thead>
                <tr>
                  <th>Usuario</th>
                  <th>Nombre Completo</th>
                  <th>Correo</th>
                  <th>Perfil</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {datosPaginados.length > 0 ? (
                  datosPaginados.map((item, index) => (
                    <tr key={index} className={usuarioSeleccionado === item.nombreUsuario ? "row-selected" : ""}>
                      <td><span className="usuario-username">{item.nombreUsuario}</span></td>
                      <td>{item.nombresApellidos}</td>
                      <td><span className="usuario-correo">{item.correo}</span></td>
                      <td>
                        <span className={`badge-perfil ${item.perfilId === "Administrador" ? "badge-admin" : "badge-estandar"}`}>
                          {item.perfilId}
                        </span>
                      </td>
                      <td>
                        <span className={`badge-estado ${item.estado === "Activo" ? "badge-activo" : "badge-inactivo"}`}>
                          <span className="badge-dot"></span>
                          {item.estado}
                        </span>
                      </td>
                      <td>
                        <div className="acciones-wrap">
                          <button className="btn-accion-tabla btn-editar" onClick={() => abrirModalEditar(item)} title="Editar">
                            <FaEdit /> Editar
                          </button>
                          <button className="btn-accion-tabla btn-clave" onClick={() => abrirModalCambioContrasena(item)} title="Cambiar contraseña">
                            <FaKey /> Contraseña
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="sin-resultados">
                      <i className="fas fa-search mr-2"></i>No se encontraron usuarios
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Paginación mejorada */}
          {totalPaginas > 1 && (
            <div className="fact-paginacion">
              <span className="fact-pag-info">
                Mostrando {indexInicio + 1}–{Math.min(indexFin, datosFiltrados.length)} de {datosFiltrados.length} usuarios
              </span>
              <div className="paginacion-wrap">
                <button 
                  className="btn-pagina btn-pag-nav" 
                  disabled={paginaActual === 1} 
                  onClick={() => setPaginaActual(1)} 
                  title="Primera"
                >
                  «
                </button>
                <button 
                  className="btn-pagina btn-pag-nav" 
                  disabled={paginaActual === 1} 
                  onClick={() => setPaginaActual(p => p - 1)} 
                  title="Anterior"
                >
                  ‹
                </button>

                {rangoInicio > 1 && <span className="btn-pagina btn-pag-dots">…</span>}

                {paginasVisibles.map((n) => (
                  <button 
                    key={n} 
                    className={`btn-pagina ${paginaActual === n ? "activa" : ""}`} 
                    onClick={() => setPaginaActual(n)}
                  >
                    {n}
                  </button>
                ))}

                {rangoFin < totalPaginas && <span className="btn-pagina btn-pag-dots">…</span>}

                <button 
                  className="btn-pagina btn-pag-nav" 
                  disabled={paginaActual === totalPaginas} 
                  onClick={() => setPaginaActual(p => p + 1)} 
                  title="Siguiente"
                >
                  ›
                </button>
                <button 
                  className="btn-pagina btn-pag-nav" 
                  disabled={paginaActual === totalPaginas} 
                  onClick={() => setPaginaActual(totalPaginas)} 
                  title="Última"
                >
                  »
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal Crear / Editar */}
      {modalVisible && (
        <div className="modal-overlay" onClick={() => setModalVisible(false)}>
          <div className="modal-usuarios" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <h5 className="modal-title-custom">
                {modoEdicion ? "✏️ Editar Usuario" : "➕ Nuevo Usuario"}
              </h5>
              <button className="modal-close" onClick={() => setModalVisible(false)}>×</button>
            </div>
            <div className="modal-body-custom">
              <div className="custom-form-group">
                <label className="custom-label">Nombre de usuario <span className="text-danger">*</span></label>
                <input 
                  type="text" 
                  className="custom-input" 
                  autoComplete="off" 
                  name="nombreUsuario" 
                  value={formulario.nombreUsuario} 
                  onChange={handleChange} 
                  disabled={modoEdicion} 
                  placeholder="ej. JPEREZ" 
                />
              </div>
              <div className="custom-form-group">
                <label className="custom-label">Nombres y apellidos <span className="text-danger">*</span></label>
                <input 
                  type="text" 
                  className="custom-input" 
                  autoComplete="off" 
                  name="nombresApellidos" 
                  value={formulario.nombresApellidos} 
                  onChange={handleChange} 
                  placeholder="ej. Juan Pérez" 
                />
              </div>
              <div className="custom-form-group">
                <label className="custom-label">Correo electrónico <span className="text-danger">*</span></label>
                <input 
                  type="email" 
                  className="custom-input" 
                  autoComplete="off" 
                  name="correo" 
                  value={formulario.correo} 
                  onChange={handleChange} 
                  placeholder="ej. juan@empresa.com" 
                />
              </div>
              {!modoEdicion && (
                <div className="custom-form-group">
                  <label className="custom-label">Contraseña <span className="text-danger">*</span></label>
                  <input 
                    type="password" 
                    className="custom-input" 
                    autoComplete="off" 
                    name="contrasenaHash" 
                    value={formulario.contrasenaHash} 
                    onChange={handleChange} 
                    placeholder="Mínimo 6 caracteres" 
                  />
                </div>
              )}
              <div className="custom-form-group">
                <label className="custom-label">Perfil <span className="text-danger">*</span></label>
                <select 
                  className="custom-input" 
                  name="perfilId" 
                  value={formulario.perfilId} 
                  onChange={handleChange}
                >
                  <option value="1">Administrador</option>
                  <option value="2">Estándar</option>
                </select>
              </div>
              <div className="custom-form-group d-flex align-items-center" style={{ gap: 10 }}>
                <input 
                  type="checkbox" 
                  name="estado" 
                  id="chkEstado" 
                  checked={formulario.estado} 
                  onChange={handleChange} 
                  style={{ width: 18, height: 18, cursor: "pointer" }} 
                />
                <label className="custom-label mb-0" htmlFor="chkEstado" style={{ cursor: "pointer" }}>
                  Usuario activo
                </label>
              </div>
            </div>
            <div className="modal-footer-custom">
              <button 
                className="btn-modal-cancelar" 
                onClick={() => { setModalVisible(false); setUsuarioSeleccionado(null); }}
              >
                Cancelar
              </button>
              <button className="btn-save-custom text-white" onClick={guardarUsuario}>
                <i className="fas fa-save mr-1"></i> Guardar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Cambiar Contraseña */}
      {modalContrasenaVisible && (
        <div className="modal-overlay" onClick={() => setModalContrasenaVisible(false)}>
          <div className="modal-usuarios" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-custom">
              <h5 className="modal-title-custom">🔒 Cambiar Contraseña</h5>
              <button className="modal-close" onClick={() => setModalContrasenaVisible(false)}>×</button>
            </div>
            <div className="modal-body-custom">
              <p className="custom-label">
                Nueva contraseña para <strong>{usuarioCambioContrasena?.nombreUsuario}</strong>
              </p>
              <div className="custom-input-group">
                <input
  type={verNuevaContrasena ? "text" : "password"}
  className="custom-input input-small"
  autoComplete="off"
  value={nuevaContrasena}
  onChange={(e) => setNuevaContrasena(e.target.value)}
  placeholder="Ingresa la nueva contraseña"
/>
                <div
                  className="custom-prepend"
                  style={{ cursor: "pointer", borderLeft: "none", borderRadius: "0 8px 8px 0" }}
                  onClick={() => setVerNuevaContrasena(!verNuevaContrasena)}
                >
                  <i className={`fas ${verNuevaContrasena ? "fa-eye-slash" : "fa-eye"}`}></i>
                </div>
              </div>
            </div>
            <div className="modal-footer-custom">
              <button 
                className="btn-modal-cancelar" 
                onClick={() => { setModalContrasenaVisible(false); setUsuarioSeleccionado(null); }}
              >
                Cancelar
              </button>
              <button className="btn-save-custom text-white" onClick={guardarNuevaContrasena}>
                <i className="fas fa-key mr-1"></i> Guardar Contraseña
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Usuarios;